import { useTranslation } from 'react-i18next';
import { useMedia } from 'react-use';
import { screen } from 'components/styles/variables';
import useHashParamFeatureFlag from 'lib/hooks/useHashParamFeatureFlag';
import { useMemo } from 'react';
import { inputStyles } from '../styles';

interface InputFieldProps {
  inputValue: string;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocus: () => void;
  handleInputKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onClick?: () => void;
}

function InputField({
  inputValue,
  handleInputChange,
  handleFocus,
  handleInputKeyDown,
  onClick,
}: InputFieldProps): JSX.Element {
  const { t } = useTranslation();
  const isMobile = useMedia(`(max-width: ${screen.xsMax})`);
  const multiMakeModelEnabled = useHashParamFeatureFlag('multiMakeModel');

  const placeholderText = useMemo(() => {
    if (multiMakeModelEnabled) {
      return isMobile ? t('srp.topBar.mmmSearchMobile') : t('srp.topBar.mmmSearchDesktop');
    }
    return isMobile ? t('srp.topBar.searchMobile') : t('srp.topBar.searchDesktop');
  }, [t, multiMakeModelEnabled, isMobile]);

  return (
    <>
      <div className="input-wrapper">
        <div className="input-adornment">
          <div className="search-icon" />
        </div>
        <input
          data-testid="text-search-input"
          className="text-search-input"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          spellCheck={false}
          onKeyDown={handleInputKeyDown}
          placeholder={placeholderText}
          autoFocus={isMobile}
          onClick={onClick}
        />
      </div>
      <style jsx>{inputStyles}</style>
    </>
  );
}
export default InputField;
